import { CanDeactivateFn } from '@angular/router';

import { CloseDialogInterface } from '../app-interfaces/close-dialog.interface';

export const dialogCloseGuard: CanDeactivateFn<CloseDialogInterface> = component => component.closeDialog();
